import React from 'react';
import { FormattedMessage } from 'react-intl';
import { EntityDomains } from '../../entity/expertises/EntityDomains';
import { EntityCasesByJurisdiction } from '../../entity/expertises/EntityCasesByJurisdiction';
import { EntityCasesByCity } from '../../entity/expertises/EntityCasesByCity';
import { EntityKeywords } from '../../entity/expertises/keywords/EntityKeywords';
import { EnterpriseKeywordsFetcher } from './EnterpriseKeywordsFetcher';
import { EntityType } from '../../entity/entity.types';
import { withEnterprise } from './EnterpriseContext';
import { EnterpriseContextType } from './enterprise.types';

type Props = EnterpriseContextType;

export class RawEnterpriseCases extends React.Component<Props> {
  id = 'enterprise-cases';

  componentDidMount() {
    window.dispatchEvent(new CustomEvent('createNav', { detail: this.id }));
  }

  render() {
    const {
      enterpriseInfos: { enterpriseId, raisonSociale, siren },
      experience: { domains, juridictions, villes, decisionCount },
    } = this.props;
    const entityInfos: {
      entityId: string;
      entityName: string;
      entityType: EntityType;
    } = {
      entityId: enterpriseId,
      entityName: raisonSociale,
      entityType: 'enterprise',
    };
    return (
      <>
        <h2 id={this.id} className="entity__section-title">
          <FormattedMessage
            id="app.pages.enterprise.cases.title"
            values={{ enterpriseName: raisonSociale }}
          />
        </h2>
        {domains.length > 0 && (
          <EntityDomains
            domains={domains}
            decisionCount={decisionCount}
            {...entityInfos}
          />
        )}
        {juridictions.length > 0 && (
          <EntityCasesByJurisdiction
            casesByJurisdiction={juridictions}
            decisionCount={decisionCount}
            {...entityInfos}
          />
        )}
        {villes.length > 0 && (
          <EntityCasesByCity
            casesByCity={villes}
            decisionCount={decisionCount}
            {...entityInfos}
          />
        )}
        <EnterpriseKeywordsFetcher siren={siren}>
          {keywords =>
            keywords.length > 0 && (
              <EntityKeywords
                keywords={keywords}
                decisionCount={decisionCount}
                {...entityInfos}
              />
            )
          }
        </EnterpriseKeywordsFetcher>
      </>
    );
  }
}

export const EnterpriseCases = withEnterprise(RawEnterpriseCases);
